<template lang="pug">
.container.is-fluid
    .columns
        .column.is-narrow
            p.title.t-1 Settings
    .columns
        .column.is-one-fifth
            p.title.is-5.has-text-weight-light.t-1 Change Password
            b-input(type="password", placeholder="Current Password", v-model="currentPassword", rounded)
            b-input.t-1(type="password", placeholder="New Password", v-model="newPassword", rounded)
            b-button.t-1(type="is-link", @click="changePassword", rounded, expanded) Submit
</template>

<script>
export default {
  name: "Settings",

  title: "Settings",

  data() {
    return {
      currentPassword: "",
      newPassword: ""
    };
  },

  methods: {
    changePassword() {
      console.log(this.newPassword);
    }
  }
};
</script>
